const RELOADED_AT = "chessla:stale-build-reloaded-at";
/** A second failure this soon after a reload is a real outage, not a stale build; let it surface. */
const RETRY_WINDOW_MS = 30_000;

type RecoveryWindow = Pick<Window, "addEventListener" | "sessionStorage" | "location">;

/**
 * A tab opened before a deploy can request code chunks the new build no longer ships.
 * Vite reports that as `vite:preloadError`; reload once so the tab picks up the current build.
 */
export const recoverFromStaleBuild = (target: RecoveryWindow = window, now = () => Date.now()) => {
  target.addEventListener("vite:preloadError", (event) => {
    let last = 0;
    try {
      last = Number(target.sessionStorage.getItem(RELOADED_AT)) || 0;
    } catch {
      // Storage can be unavailable; a single reload is still safe.
    }
    if (now() - last < RETRY_WINDOW_MS) return;
    event.preventDefault();
    try {
      target.sessionStorage.setItem(RELOADED_AT, String(now()));
    } catch {
      // See above.
    }
    target.location.reload();
  });
};
